<div class="cpcontent">
    <h2>Organizations</h2>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="add()">New Organization</button>
            <br><br>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Id
                            <i class="bi bi-arrow-down-up"  style="font-size: 1.0em;" (click)="sortGeneric(organizations,'id',sortArray)"></i>
                        </th>
                        <th>Name
                            <i class="bi bi-arrow-down-up"  style="font-size: 1.0em;" (click)="sortGeneric(organizations,'name',sortArray)"></i>
                        </th>
                        <th>Abbreviation</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let org of organizations">
                        <td>{{org.id}}</td>
                        <td class="link" (click)="selectOrg(org)">{{org.name}}</td>
                        <td>{{org.abreviation}}</td>
                        <td><button class="btn btn-warning btn-sm" (click)="delete(org)">Delete</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-6">
            <div *ngIf="organization.id != null" class="col-md-4">
                <h4 *ngIf="organization.id == 0">Add Organization</h4>
                <h4 *ngIf="organization.id > 0">Edit Organization</h4>
                <br />
                Id: {{organization.id}} 
                <br>
                <sa-input-text [(text)]="organization.name" [title]="'Name'" [required]="'none'"></sa-input-text>
                <sa-input-text [(text)]="organization.abreviation" [title]="'Abbreviation'" [required]="'none'"></sa-input-text>
                <br>
                <button class="btn btn-primary" (click)="submit()">Submit</button>
              </div>
        </div>
    </div>

</div>
